<template>
  <transition name="slide-fade-down" mode="out-in">
    /** * Types of Popups: * * alert * * info * * quest * * success */
    <div
      class="max-w-md w-full p-6 rounded shadow-md"
      :class="{
        'bg-gray-200 text-gray-900': content.type === 'info',
        'bg-watermelon-500 text-white': content.type === 'alert',
        'bg-primary-500 text-white': content.type === 'quest',
        'bg-green-500 text-white': content.type === 'success',
      }"
      @click="removePopup"
    >
      <div class="grid grid-cols-auto-1-auto col-gap-2">
        <div class="p-2 pt-0">
          <icon name="Alert" size="1.4rem" v-if="content.type === 'alert'" />
          <icon name="Quests" size="1.4rem" v-else-if="content.type === 'quest'" />
          <icon name="Check" size="1.4rem" v-else-if="content.type === 'success'" />
          <icon name="Info" size="1.4rem" v-else />
        </div>
        <div>
          <h2 class="mb-1 normal-case font-medium" v-if="content.title">{{ content.title }}</h2>
          <div class="text-base" v-if="content.text">{{ content.text }}</div>
          <div class="mt-2 text-sm" v-if="content.errors">
            <p v-for="(error, index) in content.errors" :key="index">{{ error }}</p>
          </div>
        </div>
        <div>
          <button class="button-transparent button-no-spacing">
            <icon name="Close" />
          </button>
        </div>
      </div>
      <div class="grid grid-cols-2-auto mt-4" v-if="content.actions">
        <div class="text-left">
          <wd-button
            white
            v-for="(action, index) in actionsLeft"
            :key="index"
            @input="executeAction(action.action)"
          >{{ action.title }}</wd-button>
        </div>
        <div class="text-right stack-sm">
          <wd-button
            white
            v-for="(action, index) in actionsRight"
            :key="index"
            @input="executeAction(action.action)"
          >{{ action.title }}</wd-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Popup",
  data() {
    return {};
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  components: {},
  methods: {
    removePopup() {
      this.$store.dispatch("popup/deletePopup", this.content.id);
    },
    executeAction(Action) {
      Action();
      this.removePopup();
    }
  },
  computed: {
    actionsLeft() {
      return this.content.actions.filter(e => e.location === "left");
    },
    actionsRight() {
      return this.content.actions.filter(e => e.location !== "left");
    }
  },
  created() {
    if (this.content.autohide) {
      let timeout = this.content.autohide.isInteger
        ? this.content.autohide
        : 3000;
      setTimeout(() => {
        this.$store.dispatch("popup/deletePopup", this.content.id);
      }, timeout);
    }
  }
};
</script>
